export const keywords = {
  TitleCase: 'KeyWord',
  SentenceCase: 'Keyword',
  LowerCase: 'keyword',
};
